import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCreateEmojisKey } from '../../utils/keys';
export const useCreateEmojis = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const createEmojisKey = getCreateEmojisKey();
    return useMutation((input) => client.media.createEmojis(input), {
        mutationKey: createEmojisKey,
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useCreateEmojis.js.map